// Custom formats for Angular #formatDate and DatePipe

// 17 Nov 2019, 04:12:01 AM
export const LONG_DATE_FORMAT = 'd MMM YYYY, hh:mm:ss a';

// 17 Nov 2019
export const MID_DATE_FORMAT = 'd MMM YYYY';
